import {Box} from "@mui/material";
import OriginalCalendar from "../OriginalCalendar.jsx";
import {Helmet} from "react-helmet";
import {OriginalCalendarURI} from "../Button/OriginalCalendarButton.jsx";

import {Crumbs} from "../Crumbs.jsx";
import { LatestAnnouncement } from "./Announcement.jsx";


const title = "Pro Austin 2-Step Calendar";
const desc = "6 weeks of easy scrollin, boot scootin', 2-steppin' events. Great for dancers that already know all the venues and bands."

export const OriginalCalendarPage = () => {
    return <Box>
        <Helmet>
            <meta charSet="utf-8"/>
            <meta property="og:description" content={desc}/>
            <meta property="twitter:title" content={title}/>
            <meta property="twitter:description" content={desc}/>
            <title>{title}</title>
            <meta property="description" content={desc} />
            <link rel="canonical" href={OriginalCalendarURI}/>
        </Helmet>
        {/*<PatreonAlert />*/}
        <Crumbs crumbs={[
        
            { title: "Where to Dance", href: "/where-to-dance" },
            { title: "Pro Calendar" }
        ]} />
        <LatestAnnouncement /> 
        <OriginalCalendar showFilters={true}/>
    </Box>
}